import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { CommonService } from '@app/shared/services/common.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../modal/modal.component';
import { modalButtonTitles, ModalConfig, modalContent, modalHeading } from '../../constants/modal.model';
import { DxButtonModule, DxDataGridModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { HttpService } from '@core/services/http.service';
import { AlertService } from '@core/services/alert.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { Router } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { ROLE_ID } from '@app/shared/constants/rolesConstant.model';
import {
  BOOLEAN_VALUES,
  CELL_TEMPLATES,
  DATA_FIELDS,
  DATA_GRID_CONSTANTS,
  DATE_FIELDS,
  GRID_OPTIONS,
  LOCK_STATUS_CODES,
  SEARCH_CONFIG
} from '@app/shared/constants/queue.constants';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { DataGridVO } from '../data-grid/data-grid.model';
import { NumbersOnlyDirective } from '@app/shared/directives/numberOnly.directive';
import { LocalService } from '@app/@core/services/local.service';
@Component({
  selector: 'editdatagrid',
  standalone: true,
  imports: [CommonModule, DxDataGridModule, NumbersOnlyDirective, DxPopupModule, DxTemplateModule, DxButtonModule, MatTooltipModule],
  templateUrl: './editdatagrid.component.html',
  styleUrls: ['./editdatagrid.component.scss']
})
export class EditdatagridComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() activeTab: string;
  applicationData: any[] = [];
  headers: any[] = [];
  showFilterRow: boolean = true;
  showHeaderFilter: boolean = true;
  hoverTooltipId: string | null = null;
  rowDownloadDialogData: any = null;
  customModal: NgbModalRef;
  currentPage: number = 1;
  totalItems: number = 0;
  totalPages: number = 1;
  displayMode: string = DATA_GRID_CONSTANTS.DISPLAY_MODE;
  pageSizes: number[] = [10, 25, 50];
  applicationtypes: any[] = [];
  applicationStatus: any[] = [];
  tabs: string[] = [];
  staffMembers: any[] = [];
  personsByRole: any[] = [];
  private isGeneratingPDF = false;
  currentRoleId: any;
  currentPageSize: number = 10;
  private destroy$ = new Subject<void>();
  @Input() config: DataGridVO = new DataGridVO();
  @Input() onApplicationClick?: (applicationId: string, event?: Event) => void;
  @Output() applicationClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() assign: EventEmitter<{ record: any; assign: boolean; selectedStaffMemberId?: any; personsByRole?: any }> =
    new EventEmitter<{ record: any; assign: boolean; selectedStaffMemberId?: any; personsByRole?: any }>();
  @Output() customAction: EventEmitter<{ action: string; data: any }> = new EventEmitter<{
    action: string;
    data: any;
  }>();
  @Output() rowChanged = new EventEmitter<any>();
  @ViewChild('gridContainer', { static: false }) gridContainer!: ElementRef;
  @ViewChild('registrationTemplate', { static: false, read: ViewContainerRef }) registrationTemplate!: ViewContainerRef;
  @ContentChild('actionsTemplate') projectedActionsTemplate?: TemplateRef<any>;
  @Input() actionsTemplateRef?: TemplateRef<any>;
      isMobileView: boolean = false;

  constructor(
    private commonService: CommonService,
    private ngbService: NgbModal,
    private myAppService: MyApplicationsService,
    private router: Router,
    private loaderService: LoaderService,
    private httpService: HttpService,
    private alertService: AlertService,
    private cd: ChangeDetectorRef,
    private sessionStorage: LocalService,
  ) {
    this.rowDownloadDialogData = null;
    this.initializeConfig();
    this.loadDropdownData();
  }

  private async loadDropdownData() {
    this.httpService.get(API_ENDPOINTS.APPLICATION_TYPES_LOOKUP)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.applicationtypes = response.data || [];
        }
      });
  }

  private initializeConfig(): void {
    if (!this.config || !this.config.isValid()) {
      this.config = DataGridVO.create({
        role: this.config?.role || '',
        activeTab: this.config?.activeTab || ''
      });
    }
  }

  onEditorPrepared(e: any) {
    // if (this.isDateField(e.dataField)) {
    if (this.isDateField(e.dataField) || e.dataField && this.config?.customHeaders?.some((h: any) => h?.dataField === e.dataField && (h?.dataType === 'date' || h?.allowSearch?.type === 'date'))) {
      e.editorName = 'dxDateBox';
      e.editorOptions.format = 'MM/dd/yyyy';
      e.editorOptions.mask = '99/99/9999';
      const editor = e.editorElement;

      const maxDate = new Date(9999, 11, 31);
      const pad = (n: number) => n.toString().padStart(2, '0');
      const maxDateStr = `${pad(maxDate.getMonth() + 1)}/${pad(maxDate.getDate())}/${maxDate.getFullYear()}`;
      let errorMsgElem = document.createElement('div');
      errorMsgElem.className = 'date-error-message';
      errorMsgElem.style.display = 'none';
      document.body.appendChild(errorMsgElem);

      const showErrorMsg = (msg: string) => {
        const rect = editor.getBoundingClientRect();
        errorMsgElem.textContent = msg;
        errorMsgElem.style.left = `${rect.left + window.scrollX}px`;
        errorMsgElem.style.top = `${rect.bottom + window.scrollY + 2}px`;
        errorMsgElem.style.display = 'block';
      };
      const hideErrorMsg = () => {
        errorMsgElem.style.display = 'none';
      };

      editor.addEventListener('input', (event: any) => {
        let value = event.target.value;
        value = value.replace(/[^0-9/]/g, '');
        hideErrorMsg();
        if (value.length > 2 && value.charAt(2) !== '/') {
          value = value.slice(0, 2) + '/' + value.slice(2);
        }
        if (value.length > 5 && value.charAt(5) !== '/') {
          value = value.slice(0, 5) + '/' + value.slice(5);
        }
        if (value.length > 10) {
          value = value.slice(0, 10);
        }
        if (value.length === 10) {
          const [mm, dd, yyyy] = value.split('/');
          const month = Number(mm);
          const day = Number(dd);
          const year = Number(yyyy);
          let isValid = true;
          if (
            isNaN(month) || isNaN(day) || isNaN(year) ||
            month < 1 || month > 12 ||
            day < 1 || day > 31 ||
            year < 1 || year > 9999
          ) {
            isValid = false;
          } else {
            const testDate = new Date(year, month - 1, day);
            if (
              testDate.getFullYear() !== year ||
              testDate.getMonth() !== month - 1 ||
              testDate.getDate() !== day
            ) {
              isValid = false;
            }
          }
          if (!isValid) {
            value = maxDateStr;
            showErrorMsg('Invalid date entered. Max allowed is 12/31/9999.');
          } else {
            const enteredDate = new Date(year, month - 1, day);
            if (enteredDate > maxDate) {
              value = maxDateStr;
              showErrorMsg('Date exceeds max allowed (12/31/9999).');
            }
          }
        }
        event.target.value = value;
      });
    }
  }
  valueEditorOptions = {
    stylingMode: 'outlined',
    inputAttr: { class: 'value-cell-input' }
  };
  recalculatePagerInfo() {
    if (this.applicationData.length > 0) {
      this.totalItems = this.applicationData.length;
      this.totalPages = Math.ceil(this.totalItems / this.currentPageSize);
      this.currentPage = 1;
      this.getCustomInfoText();
    } else {
      this.totalItems = 0;
      this.totalPages = 1;
      this.currentPage = 1;
      this.getCustomInfoText();
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    this.cd.detectChanges();
    if (changes['role'] || changes['config']) {
   
    }

    if (changes['data'] || (changes['config'] && this.config?.data)) {
      const currentData = this.data;
      if (Array.isArray(currentData)) {
        this.applicationData = currentData.map(row => {
          const copy: any = Object.assign({}, row);
          if (copy[DATA_FIELDS.APPLICATION_ID] !== undefined && copy[DATA_FIELDS.APPLICATION_ID] !== null) {
            copy[DATA_FIELDS.APPLICATION_ID] = String(copy[DATA_FIELDS.APPLICATION_ID]);
          }
          return copy;
        });
        this.recalculatePagerInfo();
      } else {
        this.applicationData = [];
      }
      const hasRows = Array.isArray(this.applicationData) && this.applicationData.length > 0;
      this.showFilterRow = hasRows;
      this.showHeaderFilter = hasRows;
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const removeHeaderColumnLines = () => {
      if (this.gridContainer && this.gridContainer.nativeElement) {
        const headerRows = this.gridContainer.nativeElement.getElementsByClassName('dx-header-row');
        for (const row of headerRows) {
          row.classList.remove('dx-column-lines');
        }
      }
    };
    setTimeout(removeHeaderColumnLines, 0);
    const observer = new MutationObserver(() => {
      removeHeaderColumnLines();
    });
    observer.observe(this.gridContainer.nativeElement, {
      childList: true,
      subtree: true
    });
  }

  isDateField(fieldName: string): boolean {
    return DATE_FIELDS.includes(fieldName as any);
  }

  hasData(): boolean {
    const currentData =
      this.data && this.data.length > 0
        ? this.data
        : this.applicationData && this.applicationData.length
          ? this.applicationData
          : [];
    return currentData.length > 0;
  }

  onGridOptionChanged(e: any) {
    if (e.name === GRID_OPTIONS.COLUMNS && e.fullName.includes(GRID_OPTIONS.VISIBLE) && e.component) {
      e.component.updateDimensions();
      e.component.repaint();
      this.recalculateFilteredPagerInfo(e.component);
    }
  }

  recalculateFilteredPagerInfo(e: any) {
    const visibleRows = e.getVisibleRows();
    if (visibleRows && visibleRows.length > 1) {
      this.totalItems = visibleRows.length;
      this.totalPages = Math.ceil(this.totalItems / this.currentPageSize);
      this.currentPage = 1;
    }
    else if (visibleRows && visibleRows.length === 1) {
      this.totalItems = 1;
      this.totalPages = 1;
      this.currentPage = 1;
    } else {
      this.totalItems = 0;
      this.totalPages = 1;
      this.currentPage = 1;
    }
    this.getCustomInfoText();

  }

  onPageChanged(e: any) {
    this.currentPage = e.component.pageIndex() + 1;
    this.totalItems = e.component.totalCount();
    this.totalPages = Math.ceil(this.totalItems / e.component.pageSize());
    this.currentPageSize = e.component.pageSize();
    this.getCustomInfoText();
  }
  getCustomInfoText(): string {
    const totalItems = this.totalItems || 0;
    const totalPages = this.totalPages || 1;
    const currentPage = this.currentPage || 1;

    if (totalItems === 0) {
      return `Page 1 of 1 (0 items)`;
    } else if (totalItems === 1) {
      return `Page ${currentPage} of ${totalPages} (1 item)`;
    } else {
      return `Page ${currentPage} of ${totalPages} (${totalItems} items)`;
    }
  }

  getApplicationTypeDisplayValue(key: string): string {
    if (!this.applicationtypes || !key) {
      return key || '';
    }

    const appType = this.applicationtypes.find(type => type.key === key);
    return appType ? appType.value : key;
  }

  getApplicationStatusDisplayValue(key: string): string {
    if (!this.applicationStatus || !key) {
      return key || '';
    }

    const appStatus = this.applicationStatus.find(status => status.key === key);
    return appStatus ? appStatus.value : key;
  }

  calculateStatusCellValue = (rowData: any) => this.getApplicationStatusDisplayValue(rowData.application_status);

  calculateTypeCellValue = (rowData: any) => this.getApplicationTypeDisplayValue(rowData.application_type);

  calculateLockedByCellValue = (rowData: any) => {
    const value = rowData.locked_by;
    if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
      return '---';
    }
    return value;
  };

  toggleTooltip(index: number, type: string, event?: MouseEvent) {
    if (this.hoverTooltipId === index + '-' + type) {
      this.hoverTooltipId = null;
    } else {
      this.hoverTooltipId = index + '-' + type;
    }
    if (event) {
      event.stopPropagation();
    }
  }

  toggleTooltipWithClick(index: number, type: string, tooltipRef: any, event?: MouseEvent) {
    const tooltipId = index + '-' + type;

    if (this.hoverTooltipId === tooltipId) {
      this.hoverTooltipId = null;
      tooltipRef.hide();
    } else {
      this.hoverTooltipId = tooltipId;
      tooltipRef.show();
    }

    if (event) {
      event.stopPropagation();
    }
  }

  private loadPersonsByRole() {
    this.httpService
      .get(API_ENDPOINTS.PERSONS_BY_ROLE)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response && response.data.data && Array.isArray(response.data.data)) {
            const personsWithFullNames = response.data.data.map((person: any) => ({
              ...person,
              full_name: person.full_name || `${person.first_name || ''} ${person.last_name || ''}`.trim()
            }));
            this.personsByRole = personsWithFullNames;
          }
        },
        error: _error => {
          this.personsByRole = [];
          this.alertService.error('Failed to load persons by role. Please try again later.');
        }
      });
  }

  toggleRowDownloadDialog(data: any, event?: MouseEvent) {
    // Only show the inverted arrow for the clicked row
    if (this.rowDownloadDialogData && this.rowDownloadDialogData.application_id === data.application_id) {
      this.rowDownloadDialogData = null;
    } else {
      if (data && data.application_id) {
        this.rowDownloadDialogData = data;
      } else {
        this.rowDownloadDialogData = null;
      }
    }
    if (event) {
      event.stopPropagation();
    }
  }

  viewApplication(event: Event) {
    let selectedApp = null;
    if (typeof event === 'object' && event !== null) {
      selectedApp = event;
    } else if (Array.isArray(this.applicationData)) {
      selectedApp = this.applicationData.find(app =>
        String(app.id).trim() === String(event).trim() ||
        String(app.application_id).trim() === String(event).trim()
      );
    } else if (this.applicationData && (String(this.applicationData) === String(event))) {
      selectedApp = this.applicationData;
    }
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    this.sessionStorage.setItem('applicationStatus', JSON.stringify(selectedApp?.application_status ?? null));
    if (selectedApp) {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');

      const userId = user?.id || user?.user_id || user?.userId;

      if (!userId) {
        console.error('No valid user ID found in session storage');
        return;
      }

      this.myAppService
        .getPerson(userId)
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe({
          next: personResponse => {
            const personData = personResponse.data[0];
            this.sessionStorage.setObj('personData', personData);

            const educatorName = selectedApp.educator_name ? selectedApp.educator_name : '';
            // let bannerheader = {};
            // if(selectedApp.application_status){
            //  bannerheader = {
            //   'Application ID': selectedApp.application_id,
            //   'Application Type': selectedApp.application_type,
            //   'Educator Name': educatorName,
            //   'Data Submitted': this.commonService.getFormatedDate(selectedApp.date_submitted),
            //   'Application Status': selectedApp.application_status
            // };
            // }
            // else{
            //    bannerheader = {
            //   'Application ID': selectedApp.application_id,
            //   'Application Type': selectedApp.application_type,
            //   'Educator Name': educatorName,
            //   'Data Submitted': this.commonService.getFormatedDate(selectedApp.date_submitted)
            // };
            // }

            const bannerheader = {
              'Application ID': selectedApp.application_id,
              'Application Type': selectedApp.application_type,
              'Educator Name': educatorName,
              'Data Submitted': this.commonService.getFormatedDate(selectedApp.date_submitted),
              };
              if (selectedApp.application_status) {
                bannerheader['Application Status'] = selectedApp.application_status;
              }
              if (selectedApp.re_submitted_date && selectedApp.re_submitted_date != '---') {
                bannerheader['Resubmitted Date'] = this.commonService.getFormatedDate(selectedApp.re_submitted_date);
              }

               // Add License Path to bannerheader if present in session storage and not null
              const licensePathValue = this.sessionStorage.getItem('license-path');
              if (licensePathValue && licensePathValue !== 'null') {
                let licensePathLabel = '';
                switch (licensePathValue) {
                  case '2':
                    licensePathLabel = 'Convert';
                    break;
                  case '1':
                    licensePathLabel = 'Renewal';
                    break;
                  case '3':
                    licensePathLabel = 'Initial';
                    break;
                  case '4':
                    licensePathLabel = 'Reapply';
                    break;
                  default:
                    licensePathLabel = licensePathValue;
                }
                bannerheader['License Path'] = licensePathLabel;
              }

              const licBanner = this.commonService.resolveLicenseNumberForBanner(
                selectedApp as Record<string, unknown>
              );
              if (licBanner) {
                bannerheader['License Number'] = licBanner;
              }

            const inputFormatForAppData = { bannerheader };
            this.sessionStorage.setObj('navigationData', inputFormatForAppData);

            this.myAppService
              .getAppData(`appId=${selectedApp.id}`)
              .pipe(take(1), takeUntil(this.destroy$))
              .subscribe({
                next: appResponse => {
                  const { activeversionid, license_path, cd_application_type, resolve_base_application_type } = appResponse.data.data[0];

                  if (license_path !== null && license_path !== undefined) {
                    this.sessionStorage.setItem('license-application-type', cd_application_type?.toString());
                    this.sessionStorage.setItem('license-path', license_path);
                  }
                  
                  // Store resolve_base_application_type for Resolve applications
                  if (resolve_base_application_type !== null && resolve_base_application_type !== undefined) {
                    let resolveBaseAppTypeValue = resolve_base_application_type;
                    if (this.applicationtypes?.length > 0) {
                      const matchedType = this.applicationtypes.find(type => String(type.key) === String(resolve_base_application_type));
                      resolveBaseAppTypeValue = matchedType ? matchedType.value : resolve_base_application_type;
                    }
                    this.sessionStorage.setItem('resolve_base_application_type', JSON.stringify(resolveBaseAppTypeValue));
                    console.log('[EDIT GRID] Stored resolve_base_application_type:', resolveBaseAppTypeValue);
                  }

                  if (activeversionid) {
                    this.sessionStorage.setItem('youthID', JSON.stringify(selectedApp.id || event));
                    this.sessionStorage.setItem('youthNumber', JSON.stringify(selectedApp.application_number ?? selectedApp.application_id ?? selectedApp.id));
                    this.sessionStorage.setItem('applicationID', JSON.stringify(selectedApp.id));
                    this.sessionStorage.setItem('isFirstSave', 'false');
                    this.sessionStorage.setItem('applicationType', JSON.stringify(selectedApp.application_type));
                    this.sessionStorage.setItem('currApplicationType', JSON.stringify(selectedApp.application_type));
                    this.sessionStorage.setObj('backToHome', { name: '/pages/my-app' });
                    this.sessionStorage.setObj('backToGridPage', { name: '/my-app' });
                    this.fetchAndSetApplicationFee(license_path);
                    this.router.navigate([`/pages/dynamic-routing/tab/${activeversionid}`]);
                  } else {
                    console.error('No activeversionid found in app data');
                  }
                },
                error: error => {
                  console.error('Error getting app data:', error);
                }
              });
          },
          error: error => {
            console.error('Error getting person data:', error);
          }
        });
    } else {
      console.error('Application not found:', event);
    }
  }
  tempLockQueue(rowData: any) {
    if (!rowData) {
      return;
    }
    const user = this.commonService.getCurrentUserData();
    const userId = user?.id || user?.user_id || user?.userId;
    if (!userId) {
      return;
    }
    const payload = {
      userId: userId,
      applicationNumber: rowData.id,
      lockStatus: LOCK_STATUS_CODES.TEMP_LOCKED
    };
    this.httpService
      .post(API_ENDPOINTS.TEMP_LOCK_QUEUE_APPLICATION, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (_response: any) => { },
        error: _error => {
          this.alertService.error('Failed to temp lock application. Please try again later.');
        }
      });
  }
onCellValueChanged(e: any) {
  if (e.column && e.column.dataField === 'Value') {
    if (e.oldValue !== e.value) {
      this.rowChanged.emit(e.data);
    }
  }
}
  private getModalConfig(userRoleId: number, lockStatus: string | null): ModalConfig | null {
    const isUnlocked =
      lockStatus === LOCK_STATUS_CODES.UNLOCKED ||
      lockStatus === LOCK_STATUS_CODES.TEMP_LOCKED ||
      lockStatus === null ||
      lockStatus === '---' ||
      lockStatus === undefined;

    if ((userRoleId === ROLE_ID.NDE_Analyst || userRoleId === ROLE_ID.Licensing_Analyst) && isUnlocked) {
      return {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.assign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.assignApp,
        modalContent: modalContent.assignAppToYourself,
        hasTemplate: true
      };
    }

    if ((userRoleId === ROLE_ID.NDE_Administrator || userRoleId === ROLE_ID.NDE_LeadAnalyst || userRoleId === ROLE_ID.Licensing_LeadAnalyst) && isUnlocked) {
      const dropdownOptions = this.personsByRole.map(person => ({
        label: person.full_name,
        value: person.id || person.user_id || person.userId || person.person_id
      }));

      return {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.assign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.assignApp,
        modalContent: modalContent.assignAppToStaffMember(),
        hasTemplate: true,
        hasDropdown: true,
        dropdownLabel: 'Assign To',
        dropdownOptions: dropdownOptions,
        dynamicContent: true
      };
    } else {
      return {
        buttons: [
          { text: modalButtonTitles.cancel, code: BOOLEAN_VALUES[1].CD, btnOutline: true },
          { text: modalButtonTitles.unassign, code: BOOLEAN_VALUES[0].CD, btnOutline: false }
        ],
        heading: modalHeading.unassignApp,
        modalContent: modalContent.unassignApp,
        hasTemplate: true
      };
    }
  }

  toggleAssignDialog(record) {
    const userObj = this.commonService.getCurrentUserData();
    if (!userObj || !userObj.userroles || !Array.isArray(userObj.userroles) || userObj.userroles.length === 0) {
      this.alertService.error('User roles not found. Please log in again.');
      return;
    }
    this.currentRoleId = userObj.userroles[0].id || null;
    if (!this.currentRoleId) return;

    const userRoleId = Number(this.currentRoleId);
    const isAuthorized =
      userRoleId === ROLE_ID.NDE_Analyst || userRoleId === ROLE_ID.Licensing_Analyst ||
      userRoleId === ROLE_ID.NDE_Administrator ||
      userRoleId === ROLE_ID.NDE_LeadAnalyst || userRoleId === ROLE_ID.Licensing_LeadAnalyst;

    if (!isAuthorized) return;

    const modalConfig = this.getModalConfig(userRoleId, record.lockstatus);
    if (!modalConfig) return;

    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md'
    };

    this.customModal = this.ngbService.open(ModalComponent, options);
    this.customModal.componentInstance.modalConfig = modalConfig;
    this.customModal.componentInstance.emitData.pipe(take(1)).subscribe(response => {
      if (!response) return;

      const isUnlocked =
        record.lockstatus === LOCK_STATUS_CODES.UNLOCKED ||
        record.lockstatus === null ||
        record.lockstatus === undefined ||
        record.lockstatus === '---';
      const isAdminOrLead = userRoleId === ROLE_ID.NDE_Administrator || userRoleId === ROLE_ID.NDE_LeadAnalyst || userRoleId === ROLE_ID.Licensing_LeadAnalyst;

      if (isUnlocked && isAdminOrLead) {
        this.assign.emit({ record, 'assign': true, selectedStaffMemberId: response.selectedStaffMember, personsByRole: this.personsByRole });
      } else if (isUnlocked && (userRoleId === ROLE_ID.NDE_Analyst || userRoleId === ROLE_ID.Licensing_Analyst) && LOCK_STATUS_CODES.UNLOCKED) {
        this.assign.emit({ record, 'assign': true });
      } else if (!isUnlocked) {
        this.assign.emit({ record, 'assign': false });
      }
    });
  }


  downloadRowPDF(data: any) {
    if (!data || !data.id) {
      return;
    }
    this.rowDownloadDialogData = null;

    this.isGeneratingPDF = true;
    this.loaderService.show();

    const loaderInterval: number = window.setInterval(() => {
      if (this.isGeneratingPDF) {
        this.loaderService.show();
      } else {
        window.clearInterval(loaderInterval);
      }
    }, 100);

    setTimeout(() => {
      const selectedApp = this.applicationData.find(app => app.application_id === data.application_id);
      if (!selectedApp) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
      const applicationId = selectedApp.id || data.id;

      if (!applicationId) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
      this.commonService.PDFGenerate(applicationId);
    }, 100);
     this.isGeneratingPDF = false;
    this.loaderService.hide();
  }


  // Helper method for getting cell template based on data field
  getCellTemplate(dataField: string): string | undefined {
    if (dataField === DATA_FIELDS.CD_APPLICATION_STATUS) return CELL_TEMPLATES.STATUS;
    if (dataField === DATA_FIELDS.CD_APPLICATION_TYPE) return CELL_TEMPLATES.TYPE;
    if (dataField === DATA_FIELDS.APPLICATION_ID) return CELL_TEMPLATES.APP_ID;
    if (dataField === DATA_FIELDS.LOCKED_BY || dataField === DATA_FIELDS.LOCKED_BY_CAPITAL)
      return CELL_TEMPLATES.LOCKED_BY;
    if (dataField === 'Value') return 'valueCellTemplate';
    if (dataField === 'queuesvalue') return 'queuesValueCellTemplate';
    if (dataField === 'securityvalue') return 'securityValueCellTemplate';
    if (dataField === 'registrationvalue') return 'registrationValueCellTemplate';
    return undefined;
  }


  // Convenient getters for template usage
  get customHeaders() {
    return this.config.customHeaders;
  }
  get showActionsColumn() {
    return this.config.showActionsColumn;
  }
  get showFiltering() {
    return this.config.showFiltering;
  }
  get showSearchRow() {
    return this.config.showSearchRow;
  }
  get showPaging() {
    return this.config.showPaging;
  }
  get customPageSize() {
    return this.config.customPageSize;
  }
  get customPageSizes() {
    return this.config.customPageSizes;
  }
  get customNoDataText() {
    return this.config.customNoDataText;
  }
  get customAriaLabel() {
    return this.config.customAriaLabel;
  }
  get showQueueActions() {
    return this.config.showQueueActions;
  }
  get disableApplicationClick() {
    return this.config.disableApplicationClick;
  }
  get customActionTemplate() {
    return this.config.customActionTemplate;
  }
  get data() {
    return this.config.data;
  }
  get visibleColumns() {
    return this.config.visibleColumns;
  }
  get role() {
    return this.config.role;
  }
  get configActiveTab() {
    return this.config.activeTab;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.rowDownloadDialogData) {
      return;
    }
    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }

    const downloadPopover = target.closest('.download-popover-container');
    const downloadButton = target.closest('.download-wrapper');
    if (!downloadPopover && !downloadButton) {
      this.rowDownloadDialogData = null;
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.rowDownloadDialogData = null;
  }

  onValueInput(cell: any, event: any) {
    const newValue = event.target.value;
    cell.data.apiError = null;
    if (/^\d*$/.test(newValue)) {
      if (cell.data.originalValue === undefined) {
        cell.data.originalValue = cell.data.Value;
      }
      cell.data.Value = newValue;
      cell.data.intValue = newValue === '' ? null : Number(newValue);
      cell.data.valueError = newValue === '';
      cell.data.valueChanged = (cell.data.Value !== cell.data.originalValue);
    } else {
      cell.data.valueError = true;
      cell.data.valueChanged = false;
    }
  }
   onValueInputChange(cell: any, event: any) {
    const inputEl = event.target as HTMLInputElement;
    const cursorPos = inputEl.selectionStart;
    const isBlur = event.type === 'blur';
    const rowKey = cell.data.strRuleName || cell.data.intBusinessRuleId || cell.rowIndex;
    this.onValueInput(cell, event);
    this.cd.detectChanges();
    if (!isBlur) {
      setTimeout(() => {
        const target = document.body.contains(inputEl)
          ? inputEl
          : this.gridContainer?.nativeElement?.querySelector(
              `input.value-cell-input[data-row-key="${rowKey}"]`
            ) as HTMLInputElement;
        if (target) {
          target.focus();
          const pos = Math.min(cursorPos || 0, target.value?.length || 0);
          target.setSelectionRange(pos, pos);
        }
      });
    }
    const key = cell.data.strRuleName || cell.data.applicationNumber || cell.data.intBusinessRuleId || cell.data.ruleName;
    this.rowChanged.emit({ ...cell.data, strRuleName: key });
  }
  onQueuesValueInputChange(cell: any, event: any) {
    const newValue = event.target.value;
    if (/^\d*$/.test(newValue)) {
      cell.data.queuesvalue = newValue;
      cell.data.queuesValueError = newValue === '';
    } else {
      cell.data.queuesValueError = true;
    }
    const key = cell.data.strRuleName || cell.data.applicationNumber || cell.data.intBusinessRuleId || cell.data.ruleName;
    this.rowChanged.emit({ ...cell.data, strRuleName: key });
  }

  onSecurityValueInputChange(cell: any, event: any) {
    const newValue = event.target.value;
    if (/^\d*$/.test(newValue)) {
      cell.data.securityvalue = newValue;
      cell.data.securityValueError = newValue === '';
    } else {
      cell.data.securityValueError = true;
    }
    const key = cell.data.strRuleName || cell.data.applicationNumber || cell.data.intBusinessRuleId || cell.data.ruleName;
    this.rowChanged.emit({ ...cell.data, strRuleName: key });
  }

  private fetchAndSetApplicationFee(licensePath: string): void {
    this.httpService.get('/domain/lookup?requestType=FEE_CATEGORY').pipe(take(1)).subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        const feeKeyMap: Record<string, string> = { '1': '2', '2': '7', '3': '1', '4': '8' };
        const feeKey = feeKeyMap[licensePath] || '1';
        const feeRow = data.find((item: any) => String(item.key) === feeKey);
        if (feeRow) {
          const opt = typeof feeRow.optionaldata === 'string' ? JSON.parse(feeRow.optionaldata) : feeRow.optionaldata;
          const baseFee = Number(opt?.fee) || 0;
          this.sessionStorage.setItem('applicationTotalFee', JSON.stringify(baseFee));
          this.sessionStorage.setItem('applicationFee', JSON.stringify(baseFee));
        }
        const bgCheckRow = data.find((item: any) => String(item.key) === '6');
        if (bgCheckRow) {
          const bgOpt = typeof bgCheckRow.optionaldata === 'string' ? JSON.parse(bgCheckRow.optionaldata) : bgCheckRow.optionaldata;
          this.sessionStorage.setItem('backgroundCheckFee', JSON.stringify(Number(bgOpt?.fee) || 0));
        }
        const hasApprovedExtension = JSON.parse(this.sessionStorage.getItem('has_approved_extension') || 'false');
        if (licensePath === '1' && hasApprovedExtension) {
          const extRow = data.find((item: any) => String(item.key) === '4');
          if (extRow) {
            const extOpt = typeof extRow.optionaldata === 'string' ? JSON.parse(extRow.optionaldata) : extRow.optionaldata;
            this.sessionStorage.setItem('extensionFee', JSON.stringify(Number(extOpt?.fee) || 0));
          }
        }
      }
    });
  }

  onRegistrationValueInputChange(cell: any, event: any) {
    const newValue = event.target.value;
    if (/^\d*$/.test(newValue)) {
      cell.data.registrationvalue = newValue;
      cell.data.registrationValueError = newValue === '';
    } else {
      cell.data.registrationValueError = true;
    }
    const key = cell.data.strRuleName || cell.data.applicationNumber || cell.data.intBusinessRuleId || cell.data.ruleName;
    this.rowChanged.emit({ ...cell.data, strRuleName: key });
  }

  @HostListener('window:resize')
onResize() {
  this.checkScreen();
}
checkScreen() {
  this.isMobileView = window.innerWidth <= 1024;
}
}
